import * as React from "react";
function SvgCheckboxSelected(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6zm5.81 15.573l6.964-9.847c.235-.303.292-.717.146-1.077a1.022 1.022 0 00-.841-.644 1.003 1.003 0 00-.943.467L10.8 15.431l-4.147-3.457a.99.99 0 00-1.43.165 1.09 1.09 0 00.158 1.49l4.973 4.144a1 1 0 001.455-.2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCheckboxSelected);
export default ForwardRef;
